import InspirationalFeed from './InspirationalFeed';

export default InspirationalFeed;
